import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Listings from '../pages/Listings';
import CustomerServiceListings from '../pages/CustomerServiceListings';

const ListingsRoute = () => {
  const { user } = useAuth();
  
  // Customer Service role sees simplified listings view
  if (user?.role === 'Customer Service') {
    return <CustomerServiceListings />;
  }
  
  // All other roles see the regular listings view
  return <Listings />;
};

export default ListingsRoute;

